import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { can } from '../../services/utils';
import { RootState } from '../../store/store';
import { PartialAbility } from '../../router/abilityContext';

/**
 * Will only be rendered when running in development mode locally.
 * Can be used for various debugging elements and other stuff we want to have in the app,
 * but don't want to show to the users when the actual app is built and deployed.
 */
export default function ShowIfAllowed({
  ability,
  children,
}: {
  ability: PartialAbility;
  children?: ReactNode;
}) {
  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  const isAllowed = can(farmUser, ability);

  if (!isAllowed) {
    return null;
  }

  return children as JSX.Element;
}
